jQuery.feature_import("js-history",
    () => import("./history.js"),
    mod => mod.feature_js_history
);